export default __webpack_public_path__ + "static/media/school-feeding.8c197e55.jpg";